import { TextField } from "@mui/material";
import MainSwitch from "components/MainSwitch/MainSwitch.view";
import { useStyles } from "../../useRCASettingsColumns.styles";
import { useContext, useMemo, useState } from "react";
import { IRCASettings } from "entities/RCA/RCASettingsEntity/RCASettingsEntityInterfaces";
import { useTranslation } from "react-i18next";
import { RCASettingsContext } from "contexts/RCASettingsContext.ts/RCASettingsContext";

const RCASettingsDurationTrigger = ({ row, canEdit }: { row: IRCASettings; canEdit: boolean | undefined }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { rcaSettingsChanges, setRcaSettingsChanges } = useContext(RCASettingsContext);
    const currentChanges = useMemo(
        () =>
            rcaSettingsChanges.find(
                (rcaSetting) =>
                    rcaSetting.production_line_id === row.production_line_id &&
                    rcaSetting.failure_type.failure_type_id === row.failure_type.failure_type_id,
            ),
        [rcaSettingsChanges, row],
    );
    const [value, setValue] = useState<number | undefined>(
        currentChanges?.rca_duration_trigger?.value || row.rca_duration_trigger.value,
    );
    const [check, setCheck] = useState<boolean | undefined>(currentChanges?.rca_duration_trigger?.is_enabled);

    return (
        <div className={classes.mainCell}>
            <MainSwitch
                checked={check === undefined ? row.rca_duration_trigger.is_enabled : check}
                onChange={(event) => {
                    setRcaSettingsChanges((prev) => {
                        let prevRcaSettings = [...prev];
                        const existingSettings = prevRcaSettings.findIndex(
                            (rcaSetting) =>
                                rcaSetting.production_line_id === row.production_line_id &&
                                rcaSetting.failure_type.failure_type_id === row.failure_type.failure_type_id,
                        );
                        if (existingSettings === -1) {
                            return [
                                ...prevRcaSettings,
                                {
                                    ...row,
                                    rca_duration_trigger: {
                                        ...row.rca_duration_trigger,
                                        is_enabled: event.target.checked,
                                    },
                                },
                            ];
                        } else {
                            prevRcaSettings[existingSettings] = {
                                ...prevRcaSettings[existingSettings],
                                rca_duration_trigger: {
                                    ...prevRcaSettings[existingSettings].rca_duration_trigger,
                                    is_enabled: event.target.checked,
                                },
                            };
                            return prevRcaSettings;
                        }
                    });
                    setCheck(event.target.checked);
                }}
                disabled={!canEdit}
            />
            <TextField
                className={classes.textField}
                disabled={(check === undefined ? !row.rca_duration_trigger.is_enabled : !check) || !canEdit}
                variant="outlined"
                size="small"
                value={value}
                onChange={(event) => {
                    setRcaSettingsChanges((prev) => {
                        let prevRcaSettings = [...prev];
                        const existingSettings = prevRcaSettings.findIndex(
                            (rcaSetting) =>
                                rcaSetting.production_line_id === row.production_line_id &&
                                rcaSetting.failure_type.failure_type_id === row.failure_type.failure_type_id,
                        );
                        if (existingSettings === -1) {
                            return [
                                ...prevRcaSettings,
                                {
                                    ...row,
                                    rca_duration_trigger: {
                                        ...row.rca_duration_trigger,
                                        value: Number(event.target.value),
                                    },
                                },
                            ];
                        } else {
                            prevRcaSettings[existingSettings] = {
                                ...prevRcaSettings[existingSettings],
                                rca_duration_trigger: {
                                    ...prevRcaSettings[existingSettings].rca_duration_trigger,
                                    value: Number(event.target.value),
                                },
                            };
                            return prevRcaSettings;
                        }
                    });
                    setValue(Number(event.target.value));
                }}
            />
            {t("rca.settings.minutes")}
        </div>
    );
};

export default RCASettingsDurationTrigger;
